import {processSolrPrograms} from '@nl/neu';
import Logger from '@nl/logger';
import {
	GET_HISTORY, RESET_HISTORY_START, RESET_HISTORY, HANDLE_HISTORY_ERROR,
} from '../constants';

const getHistoryAction = (programs, pageNumber, paging) => (
		{
			type: GET_HISTORY,
			programs,
			pageNumber,
			paging,
		}
);

const resetHistoryAction = () => (
	{
		type: RESET_HISTORY,
	}
);

const getFavTeamProgramsPaging = (psPaging, pageSize) => {
	const paging = {};
	paging.pageSize = pageSize;
	paging.totalCount = psPaging.count;
	paging.totalPages = psPaging.totalPage;
	paging.hasNextPage = psPaging.totalPage > psPaging.pageNumber;
	return paging;
};

export const getHistory = (pageNumber = 1, callback, errorCallback) => (dispatch, getState) => {
	const {client: {data: {hasPs}},
		config: {data: {PROGRAM_PAGE_SIZE}}} = getState();
	if (hasPs) {
		dispatch({type: RESET_HISTORY_START, pageNumber});
		window.ps.getRecentlyViewedPrograms({
			ps: PROGRAM_PAGE_SIZE,
			pn: pageNumber,
		}, (data, paging) => {
			dispatch(getHistoryAction(processSolrPrograms(data), pageNumber,
					getFavTeamProgramsPaging(paging, PROGRAM_PAGE_SIZE)));
			callback && callback(data, paging);
		}, {
			fl: 'sequence,pid,name,description,seoName,runtime,releaseDate,releaseDateLocal,beginDateTime,beginDateTimeLocal,purchaseTypeId,showTitle,seasonTitle,image,programCode,extUrl,episode,location,venue,eventId,tvRating,progType,masterImage,catId,catSEOName,cat',
		}, () => {
			if (errorCallback) {
				errorCallback(null, null);
			}
			Logger.error('Personal service error');
			dispatch({
				type: HANDLE_HISTORY_ERROR,
				errorCode: 'error',
			});
		});
	}
};

export const resetHistory = () => (dispatch) => {
	dispatch(resetHistoryAction());
};
